const Menu = [
    { header: "Sistema" },
    {
        title: "Inicio",
        group: "apps",
        icon: "home",
        name: "Home",
        visible: true,
    },
    {
        title: "Rentas",
        group: "rentas",
        icon: "swap_horizontal_circle",
        name: "Rentas",
        visible: true,
        //   items: [
        //     { name: 'Rentas', title: 'Consulta', component: 'Rentas' },
        //     { name: 'HojaRenta', title: 'Nueva', component: 'HojaRenta' },

        //  ]
    },
    {
        title: "Histórico de ventas",
        group: "ventas",
        icon: "style",
        //target: '_blank',
        name: "Ventas",
        visible: true,
    },
    {
        title: "Punto de venta",
        group: "punto-venta",
        icon: "launch",
        //target: '_blank',
        name: "PuntoVenta",
        visible: true,
    },
    {
        title: "Consulta Cortes",
        group: "apps",
        icon: "receipt",
        //target: '_blank',
        name: "Cortes",
        visible: true,
    },
    { divider: true },
    {
        title: "Precios producto",
        group: "catalogos-producto",
        icon: "attach_money",
        name: "PreciosProductos",
        visible: true,
    },
    {
        title: "Inventarios",
        group: "inventarios-producto",
        icon: "list_alt",
        name: "InventariosProductos",
        visible: true,
    },
    {
        title: "Disponibilidad",
        group: "existencias-producto",
        icon: "watch_later",
        name: "ExistenciasProductos",
        visible: true,
    },
    { header: "Catálogos" },
    {
        title: "Sucursales",
        group: "catalogo1",
        icon: "account_balance",
        name: "Sucursales",
        visible: true,
    },
    {
        title: "Clientes",
        group: "catalogo2",
        icon: "account_circle",
        name: "Clientes",
        visible: true,
    },
    {
        title: "Productos",
        group: "catalogo3",
        icon: "local_mall",
        name: "Productos",
        visible: true,
    },
    {
        title: "Conjuntos",
        group: "catalogo4",
        icon: "local_play",
        name: "Conjuntos",
        visible: true,
    },
    { divider: true },
    { header: "Administración" },
    {
        title: "Usuarios",
        group: "Usuarios",
        icon: "supervised_user_circle",
        name: "Usuarios",
        visible: true,
    },
    {
        title: "Parametros empresa",
        group: "Empresa",
        icon: "business",
        name: "ParametrosEmpresa",
        visible: true,
    },
    {
        title: "Otros catálogos",
        group: "otros-catalogos",
        icon: "library_books",
        visible: true,
        items: [{
                name: "TiposProducto",
                title: "Tipos producto",
                component: "TiposProducto",
                visible: true,
            },
            {
                name: "LineasProducto",
                title: "Líneas producto",
                component: "LineasProducto",
                visible: true,
            },
            {
                name: "MarcasProducto",
                title: "Marcas producto",
                component: "Marcas",
                visible: true,
            },
            {
                name: "Tallas",
                title: "Tallas producto",
                component: "Tallas",
                visible: true,
            },
            {
                name: "Colores",
                title: "Colores producto",
                component: "Colores",
                visible: true,
            },
            { name: "", title: "", component: "" },
        ],
    },
];
// reorder menu
// Menu.forEach((item) => {
//   if (item.items) {
//     item.items.sort((x, y) => {
//       let textA = x.title.toUpperCase();
//       let textB = y.title.toUpperCase();
//       return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
//     });
//   }
// });

export default Menu;